import { useState } from "react";
import {
  Button,
  Dialog,
  TextField,
  DialogTitle,
  DialogActions,
  DialogContent,
} from "@mui/material";

interface SendMessageModalProps {
  openDialog: boolean;
  setOpenDialog: (open: boolean) => void;
}

export const SendMessageModal = ({
  openDialog,
  setOpenDialog
}: SendMessageModalProps) => {
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setMessage("");
    setError("");
  };

  const handleSend = () => {
    if (!message.trim()) {
      setError("Message cannot be empty.");
      return;
    }
    console.log("Message sent:", message);
    handleCloseDialog();
  };

  return (
    <Dialog
      open={openDialog}
      onClose={handleCloseDialog}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle
        sx={{
          fontWeight: "bold",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
      >
        Send Message
      </DialogTitle>
      <DialogContent dividers>
        <TextField
          fullWidth
          multiline
          rows={4}
          label="Message"
          placeholder="Type your message here..."
          value={message}
          onChange={(e) => {
            setMessage(e.target.value);
            setError("");
          }}
          error={!!error}
          helperText={error}
          variant="outlined"
        />
      </DialogContent>
      <DialogActions sx={{ justifyContent: "end", p: 2 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSend}
          sx={{ textTransform: "none" }}
        >
          Send
        </Button>
      </DialogActions>
    </Dialog>
  );
};
